import React, {useMemo} from 'react';
import {COMPANY_DATA, FALLBACK_COMPANY_IDS, TOP_COMPANIES_BY_CONTENT} from '../../constants/companies';

const CompanySocialProof = ({courseSlug}) => {
  const companies = useMemo(() => {
    const courseCompanyNames = TOP_COMPANIES_BY_CONTENT[courseSlug];
    const baseCompanyNames = courseCompanyNames?.length >= 3
      ? courseCompanyNames
      : FALLBACK_COMPANY_IDS;

    // Special case for engineering tracks: replace with NVIDIA & OpenAI
    const engineeringTracks = ['software-engineering', 'engineering-management', 'ml-engineer'];
    let finalCompanyNames;

    if (engineeringTracks.includes(courseSlug)) {
      finalCompanyNames = [
        ...baseCompanyNames.slice(0, 3), // 1st to 3rd
        'OpenAI',
        ...baseCompanyNames.slice(3, 4), // 4th from original
        'NVIDIA',
        ...baseCompanyNames.slice(4, 6), // 5th & 6th from original
      ];
    } else {
      finalCompanyNames = baseCompanyNames.slice(0, 8);
    }

    return finalCompanyNames
      .filter((name) => COMPANY_DATA[name])
      .map((name) => ({
        name,
        src: COMPANY_DATA[name],
      }));
  }, [courseSlug]);

  return (
    <div className="w-full py-12">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-4 text-center text-xl font-bold text-gray">
          {'Interview prep trusted by 1M+ candidates who\'ve landed jobs at'}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
          {companies && companies.length > 0 && companies.map((item) => (
            <div key={item.name} className="col-span-1 flex justify-center items-center md:col-span-1 lg:col-span-1">
              <img
                alt={item.name}
                src={item.src}
                className="h-16 w-24 object-contain filter grayscale opacity-50"
                width="96"
                height="64"
                style={{mixBlendMode: 'darken'}}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanySocialProof;
